export default __webpack_public_path__ + "ce7ae4d2d3a7591fcd97ae84f8d0bc8a.png";